import { DefaultCard, PageLayout } from 'components';
import React from 'react';

function ErrorPage() {
  return (
    <PageLayout>
      <DefaultCard>
        <h4 style={{ textAlign: 'center' }}>
          The page you request does not exist.
        </h4>
      </DefaultCard>
    </PageLayout>
  );
}

export default ErrorPage;
